import React from 'react';
import ReactDOM from 'react-dom';
import { Root } from "./_enter/Root";
// import { configureStore } from "./store/configureStore";
// import "bootstrap/dist/css/bootstrap.min.css";
import './assets/bootstrap/bootstrap.min.css';
import "./scss/app.scss";
import './index.css';
// import "./slick-carousel/slick/slick.css";
// import "./slick-carousel/slick/slick-theme.css";
import * as serviceWorker from './serviceWorker';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// const { store, persistor } = configureStore();

// ReactDOM.render(<Root store={store} persistor={persistor} />, document.getElementById('root'));
ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
